var _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61111 10.4439H8.62833ZM15.5 10.4439H15.5172ZM22.3889 10.4439H22.4061ZM4.01898 20.5273C4.00838 20.2591 3.78783 20.0471 3.51937 20.0471H3.44444C2.53092 20.0471 1.65481 19.6803 1.00885 19.0274C0.362896 18.3746 0 17.4891 0 16.5658V3.48128C0 2.55799 0.362896 1.67251 1.00885 1.01964C1.65481 0.366777 2.53092 0 3.44444 0L26.5556 0.267949C27.4691 0.267949 28.3452 0.634726 28.9911 1.28759C29.6371 1.94046 30 2.82594 30 3.74923V16.5658C30 17.4891 29.6371 18.3746 28.9911 19.0274C28.3452 19.6803 27.4691 20.0471 26.5556 20.0471H9.61827C9.32663 20.0471 9.04953 20.1744 8.85955 20.3957L5.05575 24.826C4.75981 25.1707 4.19472 24.9739 4.17678 24.52L4.01898 20.5273Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 10,
    r: 2,
    fill: "#006460"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 10,
    r: 2,
    fill: "#006460"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 10,
    r: 2,
    fill: "#006460"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/ChatIcon.b3b87d89279b4849014d2563bdeedbc0.svg";
export { ForwardRef as ReactComponent };